import * as React from "react";
const IconRuble = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
    <path d="M37.7 17.5h-8c-.6 0-1 .4-1 1v18h-7.1c-.6 0-1 .4-1 1s.4 1 1 1h7.1v7c0 .6.4 1 1 1s1-.4 1-1v-7h7.1c.6 0 1-.4 1-1s-.4-1-1-1h-7.1v-7.6h7c3.2 0 5.7-2.6 5.7-5.7s-2.5-5.7-5.7-5.7m0 9.4h-7v-7.4h7c2 0 3.7 1.7 3.7 3.7s-1.6 3.7-3.7 3.7" />
  </svg>
);
export default IconRuble;
